// extracted by mini-css-extract-plugin
module.exports = {"link":"_0cbaba7d8a--link--kDasi","with-border":"_0cbaba7d8a--with-border--qybsf","active":"_0cbaba7d8a--active--LpSWS"};